import { useState, useEffect } from 'react';

export const useLanguage = () => {
  const [currentLanguage, setCurrentLanguage] = useState('ru');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('alpbuild-language');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const changeLanguage = (language: string) => {
    setCurrentLanguage(language);
    localStorage.setItem('alpbuild-language', language);
  };

  return { currentLanguage, changeLanguage };
};